@if (getWinningsState$ | async; as winnings) {
    @if (isPossibleWinningsUnderStakeInput()) {
        <div class="quick-bet-total-returns-possible-winnings__container">
            <span class="quick-bet-total-returns-possible-winnings__label">{{ sitecore.betslip.linear.ToReturn }}</span>
            <span class="quick-bet-total-returns-possible-winnings__value">{{ getPossibleWinnings(winnings) | bsCurrency: true }}</span>
        </div>
    } @else {
        <div class="half-sheet-total-returns" [ngClass]="{ 'placeholder total-returns': winnings === undefined }">
            <span class="quick-bet-action-button__possible-winnings-label"
                >{{ getPossibleWinningsLabel(winnings) }}
                @if (winnings.hasTaxation) {
                    <span class="theme-info quick-bet__taxation-info-icon" (click)="taxationPopupVisible = !taxationPopupVisible"></span>
                }
            </span>
            <span>
                @if (winnings.originalWinnings) {
                    <span class="quick-bet-summary__possible-winnings--original">
                        {{ winnings.originalWinnings | bsCurrency: true }}
                    </span>
                }
                <span class="quick-bet-action-button__possible-winnings-value">
                    {{ getPossibleWinnings(winnings) | bsCurrency: true }}
                </span>
            </span>
        </div>
        @if (userService.country === TAXATION_COUNTRY_ZA && winnings.taxationAmount && winnings.possibleWinnings) {
            <bs-quick-bet-taxation-za [pickIds]="pickIds" [tax]="winnings.taxationAmount" [gross]="winnings.possibleWinnings" />
        }

        <bs-digital-taxation-info [vm]="getTaxationPopupData(winnings)" [(isVisible)]="taxationPopupVisible" />
    }
}
